import React from "react";

import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

interface Props {
  rating: number | null | undefined;
}

const useStyles = makeStyles()({
  body: {
    display: "flex",
    borderRadius: 84,
    width: 32,
    height: 32,
    alignItems: "center",
    justifyContent: "center",
    border: "2px solid #C8CED8",
  },
  text: {
    color: colors.gray,
    fontWeight: 700,
  },
});

const RatingIcon: React.FC<Props> = ({ rating }) => {
  const { classes, cx } = useStyles();
  return (
    <Box className={cx(classes.body)}>
      <Typography variant="body1" className={classes.text}>
        {rating}
      </Typography>
    </Box>
  );
};

export default RatingIcon;
